import { Anchor } from '@components/anchor'
import { Container } from '@components/layout/grid'
import { Text } from '@components/text'
import { ActionButton } from '@contentful-components/action-button'
import { TEXT } from '@lib/utils/text'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './faq-hero.module.scss'

/**
 * Hero for the FAQ Page
 */
export const FaqHero: FunctionComponent<Props> = ({ links }) => {
    const handleLinkClick = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        e.preventDefault()

        const hash = e.currentTarget.hash

        document.querySelector(hash)?.scrollIntoView({
            behavior: 'smooth',
        })

        history.pushState(null, '', hash)
    }

    return (
        <Container className={styles['container']}>
            <div className={styles[`row`]}>
                <div
                    className={classNames(
                        styles['column'],
                        styles['copy-column'],
                        styles[`column-left`],
                    )}
                >
                    <div
                        className={classNames(
                            styles[`column-inner`],
                            styles[`column-inner--default`],
                        )}
                    >
                        <Text
                            tag='h1'
                            typeStyle={{
                                _: 'heading-md',
                                md: 'heading-xl',
                            }}
                            bold
                            color='primary'
                        >
                            {TEXT.frequentlyAskedQuestions}
                        </Text>
                        <div className={styles['copy-container']}>
                            <Text
                                tag='div'
                                typeStyle={{ _: 'body-lg', md: 'body-md' }}
                                color='dim'
                            >
                                {TEXT.faqSubTitle}
                            </Text>
                        </div>

                        <div className={styles.buttons}>
                            <ActionButton
                                type='ActionDownloadApp'
                                title={TEXT.getStep}
                                preset='futureFuscia'
                            />
                        </div>
                    </div>
                </div>
                <div
                    className={classNames(
                        styles['column'],
                        styles['media-column'],
                        styles[`column-right`],
                        styles[`column-order-mobile-bottom`],
                    )}
                >
                    <div
                        className={classNames(
                            styles[`column-inner`],
                            styles[`column-inner--default`],
                        )}
                    >
                        <div className={classNames(styles['topic-container'])}>
                            <Text typeStyle='body-lg' bold>
                                {TEXT.faqTopics}
                            </Text>
                            {links?.length > 0 && (
                                <ul className={styles['topic-list']}>
                                    {links.map((link) => (
                                        <Text
                                            key={link.anchor}
                                            tag='li'
                                            typeStyle='body-lg'
                                            className={classNames(
                                                styles['list-item'],
                                            )}
                                        >
                                            <Anchor
                                                href={`#${link.anchor}`}
                                                onClick={handleLinkClick}
                                            >
                                                {link.title}
                                            </Anchor>
                                        </Text>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default FaqHero

interface Props {
    links: {
        title: string
        anchor: string
    }[]
}
